<script lang="ts">
  import ListProducts from "$lib/ListProducts.svelte";
  import MetaData from "$lib/MetaData.svelte";
  import type { Product } from "$lib/types/products";
  import { selectedSort } from "./sortState.svelte";

  interface Props {
    data: {
      products: Readonly<Product[]>;
    };
  }

  let { data }: Props = $props();
  let products = $state(data?.products);
  $effect(() => {
    const sort = selectedSort.sort;
    products = data?.products?.map((x) => x)?.sort((a, b) => {
      if (sort?.key === "price") {
        return sort?.order === "asc" ? a.price - b.price : b.price - a.price;
      } else if (sort?.key === "title") {
        // For title sorting
        const comparison = a.title.localeCompare(b.title);
        return sort?.order === "asc" ? comparison : -comparison;
      } 
      return 0;
    });
  })
</script>

<MetaData
  data={{
    title: "Nettbutikk",
    description: "I nettbutikken finner du mange ulike smarte produkter.",
  }}
/>
{#if products}
  <ListProducts {products} />
{/if}
